<template>
  <div class="video-analysis">
    <el-select
      v-model="episode"
      size="small"
      placeholder="请选择视频"
      style="margin-bottom: 10px"
      @change="getList"
    >
      <el-option
        v-for="item in episodes"
        :key="item"
        :label="'第' + item + '集'"
        :value="item"
      >
      </el-option>
    </el-select>
    <ve-histogram
      width="1134px"
      :data="videoData"
      :settings="settings"
      :extend="chartExtend"
    ></ve-histogram>
  </div>
</template>

<script>
import { episodes, videoAnalysis } from "@/api/projectPractice/analysis";

export default {
  data() {
    return {
      episode: null,
      episodes: [],
      videoData: {
        columns: [
          "teamName",
          "playCount",
          "commentCount",
          "forwardCount",
          "downloadCount",
          "diggCount",
          "shareCount",
        ],
        rows: [],
      },
      settings: {
        stack: {
          数据: [
            "playCount",
            "commentCount",
            "forwardCount",
            "downloadCount",
            "diggCount",
            "shareCount",
          ],
        },
        labelMap: {
          playCount: "播放量",
          commentCount: "评论量",
          forwardCount: "转发量",
          downloadCount: "下载量",
          diggCount: "点赞量",
          shareCount: "分享量",
        },
      },
      chartExtend: {
        series(v) {
          v.forEach((i) => {
            i.barWidth = 60;
          });
          return v;
        },
      },
    };
  },
  created() {
    this.getEpisodes();
  },
  methods: {
    // 集数
    getEpisodes() {
      episodes({ classId: this.$route.query.id }).then((res) => {
        if (res.code == 0) {
          this.episodes = res.data;
          this.episode = res.data[0];
          this.getList();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    getList() {
      this.$loading.show();
      videoAnalysis({
        classId: this.$route.query.id,
        episode: this.episode,
      }).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.videoData.rows = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.video-analysis {
  text-align: left;
}
</style>